module.exports = new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = "https://mais-precoce-flow.alpha.agro.rocks/remoteEntry.js";
        script.onload = () => {
          const module = {
            get: (request) => window["pluginFlow"].get(request),
            init: (arg) => {
              try {
                return window["pluginFlow"].init(arg);
              } catch (e) {
                console.log("Problem loading remote pluginFlow", e);
              }
            },
          };
          resolve(module);
        };
        script.onerror = () => {
  const module = {
    get: () => () => {},
    init: () => () => {},
  };
  resolve(module);
}
        document.head.appendChild(script);
      });